import { Tooltip } from '../lib/tooltip/tooltip';

const tooltipMap = new WeakMap();

/**
 * @example
 * <button v-tooltip="'Some button'" aria-label="Some button">
 *   <svg></svg>
 * </button>
 *
 * @example
 * <button v-tooltip="{ content: 'Additional information', id: 'tooltip-id' }" aria-describedby="tooltip-id">
 *   Button text
 * </button>
 */
export const tooltipDirective = {
  mounted(el, binding) {
    const { content, id } =
      typeof binding.value === 'object' ? binding.value : { content: binding.value };

    const tooltip = new Tooltip({ target: el, content, id });
    tooltip.mount();
    tooltipMap.set(el, tooltip);
  },

  unmounted(el) {
    const tooltip = tooltipMap.get(el);
    if (tooltip) {
      tooltip.unmount();
      tooltipMap.delete(el);
    }
  },

  // Vue 2 support
  inserted(el, binding) {
    tooltipDirective.mounted(el, binding);
  },
  // Vue 2 support
  unbind(el) {
    tooltipDirective.unmounted(el);
  },
};
